export const RENT_AGREEMENT_SEND = 'rent_agreement:send';
export const NOTIFICATION_TENANT = 'notification:tenant';
export const WHATSAPP_RULES_TEMPLATE = 'whatsapp:template:rules'

// ——————— Whatsapp Related Permission ———————
export const BASIC_WHATSAPP_PERMISSION = 'whatsapp';
export const BAILEY_PERMISSION = 'whatsapp:bailey';